// extracted by mini-css-extract-plugin
module.exports = {"NewPatternView":"NewPatternView_NewPatternView__2a7QV","sidebar":"NewPatternView_sidebar__2fhEb","preview":"NewPatternView_preview__2qc3i"};